// convert ['A', 'B'] ==> { 'A': 'A', 'B': 'B' }
export default function convertConstants(c) {
  if (Array.isArray(c)) {
    var a = {};
    for (var i = 0; i < c.length; i++) {
      a[c[i]] = c[i];
    }
    return a;
  }
  return c;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/utils/convert-constants.js
// module id = 202
// module chunks = 0